// Meta Pixel - Código exacto de Facebook

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  // Evitar doble inicialización
  if (window.fbq) return

  // Código exacto de Facebook Pixel
  !(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  // Inicializar pixel
  window.fbq('init', '1170774765082882')
  window.fbq('track', 'PageView')
}

export const trackAddToCart = () => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
